import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I walked all over a lake!",
  "description": "",
  "published": "2012-02-18T00:00:00.000Z",
  "redirect_from": ["/blog/i-walked-all-over-a-lake/swizec/3686"],
  "categories": "Bled, Julian Alps, Lake, Lake Bled, Recreation, Slovenia, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You've heard of `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.3644444444,14.0947222222&spn=0.1,0.1&q=46.3644444444,14.0947222222%20(Lake%20Bled)&t=h",
        "title": "Lake Bled"
      }}>{`Lake Bled`}</a>{` right? The only lake in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.05,14.5&spn=10.0,10.0&q=46.05,14.5%20(Slovenia)&t=h",
        "title": "Slovenia"
      }}>{`Slovenia`}</a>{` containing the only island in Slovenia? Right!? Oh it's just one of the most beautifulest places in Slovenia.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-11-300x224.jpg",
        "alt": "Lake Bled",
        "title": "Lake Bled"
      }}></img></p>
    <p>{`Yesterday I walked all over the bad boy!`}</p>
    <p>{`The really amazing thing about Lake Bled is that every couple of years it completely freezes over. To the point you can take a walk right up to the island and endure one of the biggest brainfucks possible.`}</p>
    <p>{`Every fiber in my body fought against that first step. There you are, standing on the shore and ... you take another step. And it works. You're on water. It's a lake. And you're standing on it!`}</p>
    <p>{`Then you take a nice long walk to the island - about a kilometer and a half one way. The whole thing is just profoundly `}<em parentName="p">{`weird.`}</em></p>
    <p>{`Being out there in the middle of the lake isn't too strange, feels kind of normal until you look back and realize everything looks `}<em parentName="p">{`wrong`}</em>{`. You've been coming here your whole life, but it was ... different.`}</p>
    <p>{`The way back is even odder. Land slowly inching towards you with every step you take and your brain slowly but surely realizing that something odd is going on here.`}</p>
    <p>{`Then you have some delicious cake.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/Screen-Shot-2012-02-18-at-3.39.28-PM.png",
        "alt": "Lake walking",
        "title": "Lake walking"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-1024x764.jpg",
        "alt": "Shore view",
        "title": "Shore view"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-1-1024x764.jpg",
        "alt": "Looks like a polar expedition",
        "title": "Looks like a polar expedition"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-2-1024x764.jpg",
        "alt": "Looking back",
        "title": "Looking back"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-31-764x1024.jpg",
        "alt": "Castle Bled",
        "title": "Castle Bled"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-4-1024x764.jpg",
        "alt": "Moar ice",
        "title": "Moar ice"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-51-764x1024.jpg",
        "alt": "There was also a huge crack",
        "title": "There was also a huge crack"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-6-1024x764.jpg",
        "alt": "Not the usual view of Bled",
        "title": "Not the usual view of Bled"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-8-1024x764.jpg",
        "alt": "Island view to the other side",
        "title": "Island view to the other side"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-91-764x1024.jpg",
        "alt": "A random cyclist",
        "title": "A random cyclist"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-12-1024x764.jpg",
        "alt": "Finally, a swan",
        "title": "Finally, a swan"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.amusingplanet.com/2012/01/bled-island-in-slovenia.html"
        }}>{`Bled Island in Slovenia`}</a>{` (amusingplanet.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thealzblog.wordpress.com/2012/01/15/villa-under-extension-in-bled-slovenia/"
        }}>{`Villa 'under' Extension in Bled, Slovenia`}</a>{` (thealzblog.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.travelpod.com/travel-blog-entries/katevoss/1/1328566236/tpod.html"
        }}>{`Lakes & Caves in Ljubliana - Ljubljana, Slovenia`}</a>{` (travelpod.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://angelinthenorth.wordpress.com/2011/11/21/beautiful-bled/"
        }}>{`Beautiful Bled`}</a>{` (angelinthenorth.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://cosytravels.wordpress.com/2011/12/19/our-top-10-destinations-of-2011-part-1/"
        }}>{`Our top 10 destinations of 2011 - Part 1`}</a>{` (cosytravels.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://meganaronson.wordpress.com/2012/02/17/be-a-lake-not-a-glass/"
        }}>{`Be A Lake, Not A Glass`}</a>{` (meganaronson.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=972059ba-3eb8-46e4-919a-3a727e48727d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      